import React from 'react'

export function BronzeMedallion(props: any) {
  const { height, width } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0674 0.823101C13.1208 -0.274712 14.8763 -0.274713 15.9297 0.823099L16.3801 1.29241C17.036 1.97595 18.0044 2.26184 18.9263 2.04413L19.5523 1.89631C21.0267 1.54815 22.4959 2.49203 22.7922 3.97774L22.9304 4.67103C23.114 5.59168 23.7665 6.34885 24.65 6.66636L25.3027 6.90093C26.7171 7.40929 27.4357 8.98241 26.894 10.3844L26.625 11.0806C26.2891 11.9497 26.4294 12.9309 26.9954 13.671L27.4464 14.2609C28.3573 15.4521 28.1118 17.1593 26.9021 18.0456L26.319 18.4728C25.5653 19.025 25.1541 19.9303 25.2342 20.8612L25.297 21.5916C25.4264 23.0948 24.2883 24.4078 22.782 24.4932L22.1192 24.5308C21.1771 24.5843 20.3327 25.1299 19.8969 25.9668L19.5846 26.5664C18.8827 27.9143 17.2007 28.4081 15.8816 27.6534L15.3277 27.3364C14.5042 26.8653 13.4929 26.8653 12.6694 27.3364L12.1155 27.6534C10.7964 28.4081 9.11437 27.9143 8.41245 26.5664L8.10017 25.9668C7.66433 25.1298 6.81998 24.5843 5.87787 24.5308L5.21508 24.4932C3.70876 24.4078 2.57072 23.0948 2.70004 21.5916L2.76288 20.8612C2.84297 19.9303 2.4318 19.025 1.67809 18.4728L1.09501 18.0456C-0.114693 17.1593 -0.360212 15.4521 0.550702 14.2609L1.0017 13.671C1.56765 12.9309 1.70796 11.9497 1.37211 11.0806L1.1031 10.3844C0.561324 8.98241 1.27995 7.40929 2.6944 6.90093L3.34707 6.66636C4.23052 6.34885 4.88304 5.59168 5.06662 4.67103L5.20487 3.97774C5.50113 2.49203 6.97035 1.54815 8.44476 1.89631L9.07073 2.04413C9.99272 2.26184 10.9611 1.97595 11.617 1.29241L12.0674 0.823101ZM8.65816 14.201C9.03392 13.8173 9.64316 13.8173 10.0189 14.201L12.0274 16.252L17.5878 10.574C17.9636 10.1903 18.5728 10.1903 18.9486 10.574C19.3244 10.9577 19.3244 11.5798 18.9486 11.9635L12.7545 18.2885C12.4781 18.5708 12.0753 18.6454 11.7321 18.5124C11.5592 18.4733 11.3949 18.3852 11.2605 18.2479L8.65815 15.5905C8.28239 15.2068 8.28239 14.5847 8.65816 14.201Z"
        fill="url(#paint0_linear_1_17)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_17"
          x1="25.1902"
          y1="24.3766"
          x2="-7.62902"
          y2="6.37818"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B47D55" />
          <stop offset="1" stop-color="#E0BD8E" />
        </linearGradient>
      </defs>
    </svg>
  )
}
